import React from "react";
import { Dialog as MUIDialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import { useIntl, MessageDescriptor } from "react-intl";
import cn from "classnames";
import type { FC } from "react";

import { useStyles } from "./SubscriptionsDialog.styles";
import type { ISubscriptionsDialogProps } from "./SubscriptionsDialog.types";

export const SubscriptionsDialog: FC<ISubscriptionsDialogProps> = (props) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { title, contentText, actions = [], handleCloseDialog, children, onClose, alignActions = "center", className, ...MUIProps } = props;

  const formatStringOrMessage = (value: string | MessageDescriptor): string => {
    if (typeof value === "string") {
      return value;
    }
    return formatMessage(value);
  };

  const onClickeButton = (action: () => void) => {
    if (!action) {
      handleCloseDialog();
      return;
    }
    action();
    handleCloseDialog();
  };

  return (
    <MUIDialog classes={{ paper: cn(classes.root, className) }} onClose={onClose || handleCloseDialog} {...MUIProps}>
      {title && <DialogTitle className={classes.title}>{formatStringOrMessage(title)}</DialogTitle>}
      <DialogContent>
        {contentText && <DialogContentText className={classes.contentText}>{formatStringOrMessage(contentText)}</DialogContentText>}
        {children}
      </DialogContent>
      {actions.length > 0 && (
        <DialogActions className={alignActions === "left" ? classes.actionsLeft : undefined}>
          {actions.map((action, index) => (
            <Button
              key={index}
              onClick={() => onClickeButton(action?.handleClick!)}
              disabled={action.disabled}
              variant="contained"
              color="primary"
              className={classes.actionButton}
            >
              {formatStringOrMessage(action.name)}
            </Button>
          ))}
        </DialogActions>
      )}
    </MUIDialog>
  );
};
